{
  "version": "2026-06-18.v3-pim",
  "source": "raw_product_data.pim_category (AI Hub: postgres-dwh-gvn / analytic), 84 categories, pulled 2026-06-18",
  "note": "Masterdata GROUNDED trong PIM thật của GearVN. `category` = mã NHÓM L1 (customer-facing, ổn định để 4B phân loại). `subcategory` = mã PIM leaf thật (alias trong pim_category) — model chọn best-effort trong danh sách của nhóm. Sửa bằng cách re-pull pim_category. UNKNOWN/OTHER là cờ riêng, không phải ngành PIM.",
  "groups": [
    {
      "code": "PC",
      "label_vi": "PC / Máy bộ / Build",
      "desc": "Máy tính để bàn nguyên bộ, build PC theo cấu hình, PC gaming, máy bộ đồng bộ, workstation, server, NUC.",
      "pim_subcategories": [
        {"code": "PC", "name": "Thiết bị PC (build / PC gaming)"},
        {"code": "MT-AIO", "name": "Máy tính đồng bộ (AIO)"},
        {"code": "NUC", "name": "Máy bộ Intel NUC"},
        {"code": "MBH", "name": "Máy bộ hãng"}
      ],
      "aliases": ["pc", "build", "build pc", "máy bộ", "may bo", "pc gaming", "workstation", "server", "aio", "nuc"]
    },
    {
      "code": "LAPTOP",
      "label_vi": "Laptop",
      "desc": "Laptop nguyên chiếc (gaming, phổ thông/văn phòng).",
      "pim_subcategories": [
        {"code": "LTVP", "name": "Laptop Phổ Thông"},
        {"code": "LTCG", "name": "Laptop Gaming"}
      ],
      "aliases": ["laptop", "notebook", "lap", "laptop gaming", "laptop văn phòng", "ultrabook"]
    },
    {
      "code": "APPLE",
      "label_vi": "Apple",
      "desc": "Máy tính Apple (MacBook, iMac, Mac) và phụ kiện Apple.",
      "pim_subcategories": [
        {"code": "APPLE", "name": "Máy tính Apple"},
        {"code": "PK-APPLE", "name": "Phụ kiện Apple"}
      ],
      "aliases": ["apple", "macbook", "imac", "mac", "magic", "macos"]
    },
    {
      "code": "MAN_HINH",
      "label_vi": "Màn hình",
      "desc": "Màn hình máy tính, màn di động, máy chiếu, phụ kiện màn hình.",
      "pim_subcategories": [
        {"code": "MAN", "name": "Màn hình"},
        {"code": "MAN-DD", "name": "Màn hình di động"},
        {"code": "PK-MAN", "name": "Phụ kiện màn hình (giá treo, arm)"},
        {"code": "PRO", "name": "Máy chiếu"}
      ],
      "aliases": ["màn hình", "man hinh", "monitor", "lcd", "oled", "máy chiếu", "projector", "giá treo màn hình", "arm", "monitor arm"]
    },
    {
      "code": "LINH_KIEN",
      "label_vi": "Linh kiện PC",
      "desc": "Linh kiện rời build/nâng cấp: mainboard, CPU, VGA, RAM, SSD, HDD, tản nhiệt, quạt, nguồn, vỏ case, phụ kiện PC.",
      "pim_subcategories": [
        {"code": "MB", "name": "Bo mạch chủ"},
        {"code": "CPU", "name": "Bộ vi xử lý (CPU)"},
        {"code": "VGA", "name": "Card màn hình (VGA/GPU)"},
        {"code": "RAM", "name": "RAM"},
        {"code": "SSD", "name": "Ổ cứng SSD"},
        {"code": "HDD", "name": "Ổ cứng HDD"},
        {"code": "TN", "name": "Tản nhiệt"},
        {"code": "FAN", "name": "Quạt máy tính"},
        {"code": "PW", "name": "Nguồn máy tính (PSU)"},
        {"code": "VO", "name": "Vỏ máy tính (case)"},
        {"code": "PK-PC", "name": "Phụ kiện PC"}
      ],
      "aliases": ["linh kiện", "linh kien", "main", "mainboard", "bo mạch", "cpu", "vga", "gpu", "card màn hình", "ram", "ssd", "hdd", "ổ cứng", "tản", "tản nhiệt", "nguồn", "psu", "case", "vỏ", "quạt", "fan"]
    },
    {
      "code": "GEAR",
      "label_vi": "Gaming Gear / Giải trí",
      "desc": "Thiết bị ngoại vi gaming & giải trí: bàn phím, chuột, tai nghe, lót chuột, loa, micro, webcam, tay cầm, console.",
      "pim_subcategories": [
        {"code": "KB", "name": "Bàn phím"},
        {"code": "CHU", "name": "Chuột"},
        {"code": "TAI", "name": "Tai nghe gaming"},
        {"code": "TAI-AUDIO", "name": "Tai nghe Audio"},
        {"code": "LC", "name": "Tấm lót chuột"},
        {"code": "PKG", "name": "Phụ kiện Gear"},
        {"code": "LOA", "name": "Loa"},
        {"code": "MICRO", "name": "Microphone"},
        {"code": "CAM", "name": "Webcam"},
        {"code": "TCG", "name": "Tay cầm"},
        {"code": "CONS", "name": "Console"}
      ],
      "aliases": ["gear", "gaming gear", "bàn phím", "ban phim", "keyboard", "chuột", "chuot", "mouse", "tai nghe", "headset", "lót chuột", "mousepad", "loa", "micro", "microphone", "webcam", "tay cầm", "gamepad", "console", "phụ kiện gaming"]
    },
    {
      "code": "GHE_BAN",
      "label_vi": "Ghế / Bàn / Nội thất",
      "desc": "Ghế gaming/công thái học, bàn, nội thất setup.",
      "pim_subcategories": [
        {"code": "GHE", "name": "Ghế"},
        {"code": "BAN", "name": "Bàn"}
      ],
      "aliases": ["ghế", "ghe", "chair", "ghế gaming", "công thái học", "ergonomic", "bàn", "ban", "desk", "bàn nâng hạ", "nội thất"]
    },
    {
      "code": "THIET_BI_MANG",
      "label_vi": "Thiết bị mạng",
      "desc": "Router, switch, card mạng, dây mạng, thiết bị mạng.",
      "pim_subcategories": [
        {"code": "TBM", "name": "Thiết bị mạng"},
        {"code": "RT", "name": "Router"},
        {"code": "SW", "name": "Switch"},
        {"code": "CM", "name": "Card mạng"},
        {"code": "DM", "name": "Dây mạng"}
      ],
      "aliases": ["router", "switch", "mạng", "network", "wifi", "card mạng", "dây mạng", "lan", "access point"]
    },
    {
      "code": "PHU_KIEN",
      "label_vi": "Phụ kiện",
      "desc": "Hub/dock/cáp, phụ kiện laptop, túi, balo, đế tản nhiệt, phụ kiện thông minh, đèn.",
      "pim_subcategories": [
        {"code": "HDC", "name": "Hub - Dock - Cáp"},
        {"code": "PK-LAP", "name": "Phụ kiện Laptop"},
        {"code": "RAM-LAP", "name": "RAM Laptop"},
        {"code": "TUI", "name": "Túi chống sốc"},
        {"code": "BALO", "name": "Balo"},
        {"code": "DTN", "name": "Đế tản nhiệt"},
        {"code": "PKS", "name": "Phụ kiện thông minh"},
        {"code": "DEN", "name": "Đèn trang trí"}
      ],
      "aliases": ["phụ kiện", "phu kien", "hub", "dock", "cáp", "cap", "cable", "túi", "balo", "đế tản", "sạc", "adapter", "ram laptop", "đèn", "led"]
    },
    {
      "code": "VAN_PHONG",
      "label_vi": "Thiết bị văn phòng",
      "desc": "Máy in, thiết bị văn phòng.",
      "pim_subcategories": [
        {"code": "PRI", "name": "Máy in"}
      ],
      "aliases": ["máy in", "may in", "printer", "scan", "văn phòng"]
    },
    {
      "code": "PHAN_MEM",
      "label_vi": "Phần mềm",
      "desc": "Phần mềm, bản quyền (Windows, Office...).",
      "pim_subcategories": [
        {"code": "PM", "name": "Phần mềm"}
      ],
      "aliases": ["phần mềm", "phan mem", "software", "windows", "office", "bản quyền", "license"]
    },
    {
      "code": "DICH_VU",
      "label_vi": "Dịch vụ / Bảo hành / Custom",
      "desc": "Dịch vụ kỹ thuật: bảo hành, sửa chữa, vệ sinh, cài đặt, đổi trả, build custom. Không phải bán sản phẩm mới.",
      "pim_subcategories": [
        {"code": "DV", "name": "Dịch vụ"},
        {"code": "CT", "name": "Custom"}
      ],
      "aliases": ["dịch vụ", "dich vu", "service", "bảo hành", "bao hanh", "bh", "sửa", "vệ sinh", "cài win", "đổi trả", "warranty", "custom", "doa"]
    },
    {
      "code": "OTHER",
      "label_vi": "Khác",
      "desc": "Có sản phẩm/nhu cầu rõ nhưng không thuộc nhóm PIM nào ở trên.",
      "pim_subcategories": [],
      "aliases": ["khác", "khac", "other"]
    },
    {
      "code": "UNKNOWN",
      "label_vi": "Chưa rõ",
      "desc": "Không đủ thông tin trong text để xác định ngành hàng (vd 'khách checkin nhận quà').",
      "pim_subcategories": [],
      "aliases": ["chưa rõ", "chua ro", "unknown", "n/a"]
    }
  ]
}
